export enum PendingTaskOrderBy {
  TaskTypeDescending = 1,
  TaskTypeAscending,
  DateDescending,
  DateAscending,
  StatusDescending,
  StatusAscending,
}
